// src/pages/InsuranceModal.js
import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import './InsuranceModal.css';

const InsuranceModal = ({ deductible, deductiblePercent, coveragePercent, description, onAccept, onCancel }) => {
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({contentRef: printRef, documentTitle: 'Rental-Protection-Coverage',});

    const formattedDeductible = (+deductible || 0).toFixed(2);
    const formattedDeductiblePercentage = (+deductiblePercent || 0).toFixed(2);
    const formattedCoverage = (+coveragePercent || 0).toFixed(2)

    return (
        <div className="insurance‑modal‑overlay">
            <div className="insurance‑modal" ref={printRef}>
            <h2>Rental Protection Coverage Policy</h2>

            {description && <div className="coverage-description"><p>{description}</p></div>}

            <p>
                When you select Rental Protection Coverage, you’ll pay a{' '}
                {formattedCoverage}%
                fee based on your rental subtotal. This coverage protects you from
                unexpected <strong>accidental damage</strong> and limits your out-of-pocket cost to{' '}
                <strong>{formattedDeductiblePercentage}% of each item’s value, up to a maximum of{' '}
                ${formattedDeductible} per item.</strong>
            </p>

            <div className="modal-buttons">
                <button onClick={onAccept} className="btn-primary">Accept & Continue</button>
                <button onClick={onCancel} className="btn-secondary">Cancel</button>
                <button onClick={handlePrint} className="btn-link">Print This Form 🖨️</button>
            </div>
        </div>
        </div>
    );
};
export default InsuranceModal;